import * as GQL from '~/graphql/generated/client';

/**
 * Advanced reports awaiting approval, plus ones the user submitted.
 *
 * Mirrors useUserTasksPaginated / useUserControlTasksPaginated so the tasks
 * page treats all three kinds the same way.
 */
export const useUserReportTasksPaginated = (input: {
  page: number;
  pageSize: number;
  search?: string;
  status?: GQL.AssignmentStatusType;
  filter?: GQL.TaskFilter;
}) => {
  const { data, loading, error, refetch } =
    GQL.useUserReportTasksPaginatedQuery({
      variables: {
        input: {
          pagination: { page: input.page, pageSize: input.pageSize },
          search: input.search,
          status: input.status,
          filter: input.filter,
        },
      },
      fetchPolicy: 'cache-and-network',
    });

  return {
    tasks: data?.userReportTasksPaginated.tasks ?? [],
    totalCount: data?.userReportTasksPaginated.totalCount ?? 0,
    hasNextPage: data?.userReportTasksPaginated.hasNextPage ?? false,
    hasPreviousPage: data?.userReportTasksPaginated.hasPreviousPage ?? false,
    loading,
    error,
    refetch,
  };
};

/**
 * Pending report reviews waiting on the user — the toggle badge.
 *
 * Its own query, deliberately unfiltered: the paginated list carries the
 * search text, status chip and page of whichever tab is open, and a badge whose
 * whole job is to be seen from another tab cannot inherit those.
 */
export const usePendingReportTaskCount = () => {
  const { data } = GQL.usePendingReportTaskCountQuery({
    fetchPolicy: 'cache-and-network',
  });
  return data?.pendingReportTaskCount ?? 0;
};
